import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  useTheme,
} from "@mui/material";
import SkeletonPDFPreview from "@pages/ManualDocumentV2/components/skeleton/PdfPreview";
import { Eye } from "lucide-react";
import React, { Suspense, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { CreateDocumentDto } from "src/@types/manualDocument/createDocument";
import lazyWithRetry from "src/lazyWithRetry";

const PDFGenerator = lazyWithRetry(
  () => import("src/pages/ManualDocumentV2/components/pdf"),
);

interface IPreviewPdfDialogProps {
  onSubmit: () => void;
  isSubmitting: boolean;
  submitDisabled: boolean;
  translate: (text: any, options?: any) => string;
}

export const PreviewPdfDialog: React.FC<IPreviewPdfDialogProps> = (props) => {
  const { translate } = props;
  const { palette } = useTheme();
  const pdfBlobRef = useRef<null | Blob>(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const { watch } = useFormContext<CreateDocumentDto>();

  const handleClose = () => {
    setIsPreviewOpen(!isPreviewOpen);
  };

  const handleOpenDialog = () => {
    setIsPreviewOpen(!isPreviewOpen);
  };
  return (
    <>
      <Button
        variant="outlined"
        size="small"
        endIcon={<Eye strokeWidth="1.5px" size="18px" />}
        onClick={handleOpenDialog}
      >
        {translate("preview_pdf")}
      </Button>
      <Dialog
        open={isPreviewOpen}
        onClose={handleClose}
        fullScreen
        PaperProps={{
          sx: {
            bgcolor: "rgba(0, 0, 0, 0.2)",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogContent>
          <Box
            sx={{
              flex: 1,
              overflow: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              py: 3,
            }}
          >
            <Suspense fallback={<SkeletonPDFPreview />}>
              <PDFGenerator watch={watch} pdfBlobref={pdfBlobRef} />
            </Suspense>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            background: palette.background.default,
            borderTop: `1px solid ${palette.text.borderLine}`,
          }}
        >
          <Stack direction="row" spacing={1} sx={{ mr: 10 }}>
            <Button onClick={handleClose} variant="outlined" size="small">
              {translate("close")}
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
};
